const InvoiceTemplateEnum = {
  REPUBLIC_PALAZA: 1,
  ARIZANA_CONDOTEL: 2
}
export default InvoiceTemplateEnum


// WEBPACK FOOTER //
// ./src/enum/invoiceTemplateEnum.js